import React from 'react';
import Icon from '../../../components/AppIcon';

const IndependenceStatement = () => {
  const ethicalFramework = [
    {
      title: "Professional Independence",
      description: "We maintain complete independence from clients\' business interests and outcomes",
      icon: "Shield",
      details: [
        "No financial interest in client companies",
        "Independent fee structure unrelated to valuation outcomes",
        "Objective analysis free from external influence"
      ]
    },
    {
      title: "Conflict Management",
      description: "Rigorous conflict checking and management procedures for all engagements",
      icon: "AlertTriangle",
      details: [
        "Comprehensive conflict database maintained",
        "Pre-engagement conflict screening process",
        "Clear protocols for potential conflict resolution"
      ]
    },
    {
      title: "Regulatory Compliance",
      description: "Full compliance with international and regional professional standards",
      icon: "FileCheck",
      details: [
        "IVS (International Valuation Standards) compliance",
        "Local regulatory requirements adherence",
        "Regular compliance audits and reviews"
      ]
    },
    {
      title: "Quality Assurance",
      description: "Multi-level review process ensures accuracy and defensibility",
      icon: "CheckCircle",
      details: [
        "Peer review of all valuation reports",
        "Technical review by senior partners",
        "Independent quality control procedures"
      ]
    }
  ];

  const courtCredentials = [
    {
      jurisdiction: "UAE Federal Courts",
      status: "Court-Nominable Expert",
      since: "2019",
      cases: "25+"
    },
    {
      jurisdiction: "Bahrain Commercial Court",
      status: "Approved Expert Witness",
      since: "2020",
      cases: "18+"
    },
    {
      jurisdiction: "Saudi Commercial Court",
      status: "Litigation Support Specialist",
      since: "2021",
      cases: "12+"
    },
    {
      jurisdiction: "Qatar Civil & Commercial Court",
      status: "Expert Valuer",
      since: "2022",
      cases: "8+"
    }
  ];

  return (
    <div className="bg-background">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-accent/10 rounded-full mb-6">
            <Icon name="Scale" size={32} className="text-accent" />
          </div>
          <h2 className="text-3xl font-semibold text-text-primary mb-4">
            Independence & Professional Standards
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            Our commitment to independence and ethical practice forms the foundation of our credibility as expert witnesses and trusted advisors in complex valuation matters.
          </p>
        </div>

        {/* Independence Statement */}
        <div className="bg-card rounded-xl shadow-brand border border-border p-8 ">
          <div className="border-l-4 border-accent pl-6">
            <h3 className="text-xl font-semibold text-text-primary mb-4">
              Professional Independence Statement
            </h3>
            <p className="text-text-secondary leading-relaxed mb-4">
            Northbridge Valuation & Advisory maintains strict professional independence in all engagements. We have no financial interest in the outcome of our valuations and receive no contingent fees based on valuation conclusions. Our compensation is based solely on time and expertise provided, ensuring objective and unbiased analysis.            </p>
            <p className="text-text-secondary leading-relaxed">
            We adhere to the highest ethical standards as defined by the National Association of Valuators & Analysts (NACVA) and the American Institute of Certified Public Accountants (AICPA) and maintain professional indemnity insurance to protect our clients' interests.            </p>
          </div>
        </div>

        {/* Ethical Framework */}
        {/* <div className="grid lg:grid-cols-2 gap-8 mb-12">
          {ethicalFramework?.map((framework, index) => (
            <div key={index} className="bg-card rounded-xl shadow-brand border border-border p-6">
              <div className="flex items-start space-x-4 mb-4">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-accent/10 rounded-lg flex items-center justify-center">
                    <Icon name={framework?.icon} size={24} className="text-accent" />
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-text-primary mb-2">
                    {framework?.title}
                  </h3>
                  <p className="text-text-secondary mb-4">
                    {framework?.description}
                  </p>
                </div>
              </div>
              
              <div className="space-y-2">
                {framework?.details?.map((detail, detailIndex) => (
                  <div key={detailIndex} className="flex items-start space-x-3">
                    <Icon name="Check" size={16} className="text-success mt-0.5 flex-shrink-0" />
                    <span className="text-sm text-text-secondary">{detail}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div> */}

        {/* Court Credentials */}
        {/* <div className="bg-muted/30 rounded-xl p-8">
          <h3 className="text-2xl font-semibold text-text-primary text-center mb-8">
            Court Recognition & Expert Witness Credentials
          </h3>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {courtCredentials?.map((credential, index) => (
              <div key={index} className="bg-card rounded-lg shadow-brand border border-border p-6 text-center">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-success/10 rounded-full mb-4">
                  <Icon name="Gavel" size={24} className="text-success" />
                </div>
                
                <h4 className="text-sm font-semibold text-text-primary mb-2">
                  {credential?.jurisdiction}
                </h4>
                
                <p className="text-xs text-accent font-medium mb-3">
                  {credential?.status}
                </p>
                
                <div className="space-y-2">
                  <div className="flex items-center justify-center text-xs text-text-secondary">
                    <Icon name="Calendar" size={14} className="mr-1" />
                    Since {credential?.since}
                  </div>
                  <div className="flex items-center justify-center text-xs text-text-secondary">
                    <Icon name="FileText" size={14} className="mr-1" />
                    {credential?.cases} Cases
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8 text-center">
            <p className="text-sm text-text-secondary max-w-2xl mx-auto">
              Our court-nominable status across multiple jurisdictions demonstrates our credibility and expertise in providing expert testimony for complex valuation disputes and litigation support matters.
            </p>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default IndependenceStatement;